import { DefaultCommandProps } from './index';

import Base from './base';

const DatetimeSelect = ({ label, value, onChange }: DefaultCommandProps) => (
  <Base
    id={label}
    onChange={(value) => onChange(label, value)}
    type="datetime-local"
    value={value}
  />
);

export default DatetimeSelect;
